import React, { Suspense } from "react";
import { Hotspot, Scene, TourData } from "../../../../Types";
import { useParametersStore } from "../../../../api/Zustand";
import XRWaypoint from "./Closed/XRWaypoint";
import XRPopup from "./Closed/XRPopup";
import * as THREE from "three";
import XRQuiz from "./Closed/XRQuiz";
import XRAudio from "./Closed/XRAudio";
import { create } from "zustand";
import XRExternalLink from "./Closed/XRExternalLink";

type xrPopupStoreType = {
  isOpen: boolean;
  target: string;
  dir: THREE.Vector3 | undefined;
  openPop: (target: string, dir: THREE.Vector3) => void;

  openCustomPop: (
    target: number,
    dir: THREE.Vector3 | number[],
    hardOrSoft: 0 | 1
  ) => void;

  openSingularCustomPop: (str: string) => void;

  customIsOpen: boolean;
  customTargetScene: number;

  customDir: THREE.Vector3 | number[];
  customHardOrSoft: 0 | 1;

  singularCustomIsOpen?: string;
  closePop: () => void;
};

export const useXRPopupStore = create<xrPopupStoreType>()((set) => ({
  isOpen: false,
  target: "",
  dir: undefined,
  openPop: (target: string, dir: THREE.Vector3) =>
    set({ isOpen: true, target: target, dir: dir }),
  openCustomPop: (
    target: number,
    dir: THREE.Vector3 | number[],
    hardOrSoft: 0 | 1
  ) =>
    set({
      isOpen: true,
      customIsOpen: true,
      customDir: dir,
      customHardOrSoft: hardOrSoft,
      customTargetScene: target,
    }),

  customIsOpen: false,
  customDir: new THREE.Vector3(0, 0, 0),
  customHardOrSoft: 0,
  customTargetScene: 1,

  openSingularCustomPop: (str: string) =>
    set({ isOpen: true, singularCustomIsOpen: str }),

  closePop: () =>
    set({
      singularCustomIsOpen: undefined,
      customIsOpen: false,
      isOpen: false,
      target: "",
      dir: undefined,
    }),
}));

const XRHotspots = (props: {
  transition: boolean;
  currentScene: Scene;
  tourData: TourData;
}) => {
  const { tourID, userID } = useParametersStore();
  const { transition, currentScene, tourData } = props;
  const hotspotsWrapper = React.useRef<THREE.Group>(null);

  // @ts-expect-error
  const parsedHotspots: Hotspot[] = React.useMemo(() => {
    const hotspots = currentScene.hotspots;

    const newHotspots = hotspots.map((hs) =>
      hs.type === "popup"
        ? tourData.popups.find((one) => one.id === hs.target)?.type === "video"
          ? {
              ...hs,
              type: "video",
              title: tourData.popups.find((one) => one.id === hs.target)?.title,
              target: tourData.popups.find((one) => one.id === hs.target)
                ?.video,
            }
          : hs
        : hs
    );

    return newHotspots;
  }, [currentScene.hotspots, tourData]);

  return (
    <group name="gruppo hotspot" ref={hotspotsWrapper}>
      {!transition &&
        parsedHotspots.map((hs: Hotspot) =>
          hs.type === "transition" ? (
            <Suspense key={hs.id}>
              <XRWaypoint
                pos={[hs.x, hs.y, hs.z]}
                hs={hs}
                // hover={hover}
                tourData={tourData}
              />
            </Suspense>
          ) : hs.type === "popup" ? (
            <Suspense key={hs.x + hs.y}>
              <XRPopup
                pos={[hs.x, hs.y, hs.z]}
                key={hs.id}
                hs={hs}
                tourData={tourData}
              />
            </Suspense>
          ) : hs.type === "quiz" ? (
            <Suspense key={hs.x + hs.y}>
              <XRQuiz
                hs={hs}
                pos={new THREE.Vector3(hs.x, hs.y, hs.z)}
                tourData={tourData}
                tourID={tourID}
                userID={userID}
              />
            </Suspense>
          ) : hs.type === "audio" ? (
            <Suspense key={hs.x + hs.y}>
              <XRAudio tourID={tourID} pos={[hs.x, hs.y, hs.z]} hs={hs} />
            </Suspense>
          ) : hs.type === "link" || hs.type === "video" ? (
            <Suspense key={hs.x + hs.y}>
              <XRExternalLink
                hs={hs}
                pos={[hs.x, hs.y, hs.z]}
                tourData={tourData}
              ></XRExternalLink>
            </Suspense>
          ) : null
        )}
    </group>
  );
};

export default XRHotspots;
